const GRANT_GRACE_MS = 3 * 24 * 60 * 60 * 1000;
const PRO_GRANT_KEYS = ["Pro", "PRO10-90", "Pro-10", "PRO10", "sub_100_12m"];

function getGrantExpiresMs(grant) {
  if (!grant) {
    return null;
  }
  if (typeof grant.expiresAsNumber === "number") {
    return grant.expiresAsNumber;
  }
  if (grant.expires === undefined || grant.expires === null) {
    return null;
  }
  const parsed = Date.parse(grant.expires);
  return Number.isNaN(parsed) ? null : parsed;
}

function getActiveGrantPlanKey(organization, nowMs) {
  const now = nowMs == null ? Date.now() : nowMs;
  const grant = organization && organization.account && organization.account.entitlementGrant;
  if (!grant || !grant.planKey) {
    return null;
  }
  const expiresMs = getGrantExpiresMs(grant);
  if (expiresMs !== null && expiresMs + GRANT_GRACE_MS <= now) {
    return null;
  }
  return grant.planKey;
}

function orgHasProEntitlementGrant(organization, nowMs) {
  const key = getActiveGrantPlanKey(organization, nowMs);
  if (!key) {
    return false;
  }
  if (PRO_GRANT_KEYS.indexOf(key) !== -1) {
    return true;
  }
  return String(key)
    .toLowerCase()
    .replace(/[_\s-]+/g, "")
    .includes("pro");
}

function orgHasGuestAskEntitlementGrant(organization, nowMs) {
  return getActiveGrantPlanKey(organization, nowMs) === "GuestAsk";
}

module.exports = {
  getActiveGrantPlanKey,
  orgHasProEntitlementGrant,
  orgHasGuestAskEntitlementGrant,
};
